import { cn } from '@/lib/utils';
import React, { ReactNode } from 'react';
import { TabType, TabVariant } from './BaseTabs';
import { TabsTrigger } from '@/components/ui/tabs';

export function BaseTabsTrigger({
  isTablet,
  hideTabTriggers,
  tooltip,
  id,
  disabled,
  title,
  onTabClick,
  variant,
}: TabType & {
  isTablet: boolean;
  hideTabTriggers: boolean;
  variant: TabVariant;
  onTabClick: (tabId: string) => any;
}) {
  const classNames = {
    primary: cn(
      `z-20 hover:bg-neutral-25 disabled:opacity-100`,
      `${
        isTablet
          ? hideTabTriggers
            ? 'hidden'
            : 'px-2 w-screen border-none text-xs sm:text-sm first-of-type:rounded-none last-of-type:rounded-none whitespace-pre-wrap h-100'
          : hideTabTriggers && 'hidden'
      }`,
      `${disabled ? (isTablet ? 'hidden' : 'text-disabled cursor-not-allowed') : ''}`
    ),
    secondary: cn(
      `bg-transparent disabled:bg-transparent disabled:opacity-100 disabled:text-gray-400 h-8 flex text-sm font-semibold border-none data-[state=active]:bg-gray-300 dark:data-[state=active]:bg-primary-600 data-[state=active]:font-semibold data-[state=active]:text-dark dark:data-[state=active]:text-white rounded-md px-2 py-3`
    ),
    'secondary-plain': cn(
      `bg-transparent  text-neutral-700 disabled:bg-transparent disabled:opacity-100 disabled:text-gray-400 h-8 flex text-sm font-medium  data-[state=active]:bg-card dark:data-[state=active]:bg-primary-600 data-[state=active]:font-semibold data-[state=active]:text-neutral-700 dark:data-[state=active]:text-white rounded-md px-2 py-3 border border-transparent  data-[state=active]:border-neutral-100`
    ),
    'secondary-line': cn(
      `relative bg-transparent disabled:bg-transparent disabled:opacity-100 disabled:text-gray-400 
        h-8 flex text-sm font-semibold border-none 
        data-[state=active]:bg-transparent 
        data-[state=active]:font-semibold data-[state=active]:text-dark dark:data-[state=active]:text-white 
        rounded-md px-2.5 text-center py-3 transition-all duration-300
        after:content-[''] after:absolute after:left-0 after:bottom-0 
        after:h-[2px] after:w-full after:bg-gray-300 dark:after:bg-gray-600 
        data-[state=active]:after:bg-primary-600`
    ),
  };
  const testId = typeof title === 'string' ? title.toLowerCase().replace(' ', '_') : id;
  return (
    <TabsTrigger
      data-testid={'page_tabs_' + testId}
      disabled={disabled}
      className={classNames[variant as 'primary']}
      key={id + '_tabs_trigger'}
      value={id}
      onClick={() => onTabClick(id)}
    >
      {title}
    </TabsTrigger>
  );
}
